import React, { useState, useEffect,  } from "react";
import { DragDropContext, Droppable, DropResult } from "react-beautiful-dnd";
import {
  getSelectedMustDoActionArrayFromObject,
  populateSavedConfigWithDefaultData,
  checkForDataFieldsValidation,
  getMustDoSavedConfigCustom,
  convertStateToConfigStructureCustom,
} from "../mustDoActionService";
import "./mustDoActionConfig.css";
import "../../mandatoryConfigCommon.css";
import { SingleMustDoDataPointState, SelectedMustDoActionTask, InputLengthValidations } from "../types";

import MustDoActionTaskItem from "./MustDoActionTaskItem";

interface Props{
     name:string,
    values:any,
    setValues: React.Dispatch<React.SetStateAction<any>>;
setAreDataFieldsValid?:(isValid: boolean) => void;
}

const MustDoActionConfigCustom=(props:Props) =>  {
  // States ->
  const [areDataFieldsValid, setAreDataFieldValid] = useState<boolean>(true);
  const [selectedMustDoAction, setSelectedMustDoAction] = useState<
    Record<string, SingleMustDoDataPointState[]>
  >({});
  const [loading, setLoading] = useState<boolean>(true);
  const [selectedMustDoActionTasks, setSelectedMustDoActionTasks] = useState<
    SelectedMustDoActionTask[]
  >([]);
 const inputLengthValidations:InputLengthValidations={
          max: { title: 25, unit: 9 },
          min: { title: 5, unit: 2 },
    }
  const [expandedTaskId, setExpandedTaskId] = useState<string | null>(null);
  const [isDragging, setIsDragging] = useState<boolean>(false);

  const handleToggleSelect = (taskId: string) => {

    setSelectedMustDoActionTasks((prevTasks) => {
      const updatedTasks = prevTasks.map((task) =>
        task.id === taskId ? { ...task, selected: !task.selected } : task
      );

      return updatedTasks.sort(
        (a, b) => (b.selected ? 1 : 0) - (a.selected ? 1 : 0)
      );
    });


    if (taskId === expandedTaskId) {
      setExpandedTaskId(null);
    }
  };

  const handleToggleExpand = (taskId: string) => {
    if (!isDragging) {
    
      setExpandedTaskId((prev) => (prev === taskId ? null : taskId));
    }
  };
 
  const handleMustDoEditorChange = (
    id: string,
    newValues: Array<SingleMustDoDataPointState>
  ) => {
    setSelectedMustDoAction((pre) => ({
      ...pre,
      [id]: newValues,
    }));
  };
  const reorder = (
    list: SelectedMustDoActionTask[],
    startIndex: number,
    endIndex: number
  ): SelectedMustDoActionTask[] => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };
  const onDragStart = () => setIsDragging(true);
  const onDragEnd = (result: DropResult) => {
    setIsDragging(false);
    if (!result.destination) return;

    const reorderedTasks = reorder(
      selectedMustDoActionTasks,
      result.source.index,
      result.destination.index
    );

    setSelectedMustDoActionTasks(reorderedTasks);
  };

  // Initializing the component's data variables ->
  const fetchData = async () => {
    try {
     
      setLoading(true);
  
      const savedConfig = await getMustDoSavedConfigCustom(props.values);
      const tasksArray = getSelectedMustDoActionArrayFromObject(savedConfig);

      const populatedSavedConfig =
        populateSavedConfigWithDefaultData(savedConfig);
      setSelectedMustDoAction(populatedSavedConfig);
      // if none of the tasks array item's selected key is true , means that user came for the first time , so then make the selected true for all items of task array
      // Check if any tasks are selected
      const anyTaskSelected = tasksArray.some((task) => task.selected);
      if (!anyTaskSelected) {
        // If none are selected, update all tasks to selected: true
        const updatedTasksArray = tasksArray.map((task) => ({
          ...task,
          selected: true,
        }));
        setSelectedMustDoActionTasks(updatedTasksArray);
      } else {
        setSelectedMustDoActionTasks(tasksArray);
      }
    } catch (error) {
      console.error("Error loading configuration:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
   const savingMustDoAction=()=>{
     if (!areDataFieldsValid) return;
    const selectedItems = selectedMustDoActionTasks.filter(
      (task) => task.selected
    );
const selectedMustDoActionNew: Record<
      string,
      SingleMustDoDataPointState[]
    > = {};
    selectedItems.forEach((item) => {
      selectedMustDoActionNew[item.actionId] =
        selectedMustDoAction[item.actionId];
    });
    const currency=props.values?.currency?.value??null
   const val= convertStateToConfigStructureCustom(selectedMustDoActionNew,currency);
   return val
}
  useEffect(() => {
    const isCheck=checkForDataFieldsValidation(
        selectedMustDoActionTasks,
        selectedMustDoAction,
        inputLengthValidations
      )
      
    if(props?.setAreDataFieldsValid)
    props?.setAreDataFieldsValid(isCheck)

    if(isCheck){
        const val=savingMustDoAction();
        props.setValues({
            ...props.values,
            mustDoActionCard:{
                ...props.values["mustDoActionCard"],
                value:val?.mustDoActionCardData??props.values?.["mustDoActionCard"]?.value,
                isValueUpdated:true
            },
            outletTabFilters:{
                 ...props.values["outletTabFilters"],
                value:val?.oultetTabFilterData??props.values?.["outletTabFilters"]?.value,
                isValueUpdated:true
            }
        })
    }
  
  }, [selectedMustDoActionTasks, selectedMustDoAction]);


  return (
    
          <>
            <DragDropContext onDragEnd={onDragEnd} onDragStart={onDragStart}>
              <Droppable droppableId="droppable">
                {(provided) => (
                  <div
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    className="configuration-items-container "
                    style={{padding:"6px"}}
                  >
                    {selectedMustDoActionTasks.map((task, index) => (
                      <MustDoActionTaskItem
                        key={task.id}
                        task={task}
                        index={index}
                        expandedTaskId={expandedTaskId}
                        handleToggleSelect={handleToggleSelect}
                        handleToggleExpand={handleToggleExpand}
                        handleMustDoEditorChange={handleMustDoEditorChange}
                        selectedMustDoAction={selectedMustDoAction}
                        inputLengthValidations = {inputLengthValidations}
                      />
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </>
        
    );
}

export default MustDoActionConfigCustom;
